import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Lista from './laudoImportacaoLista';
import Form from './laudoImportacaoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import LaudoImportacaoProcesso from './laudoImportacaoProcesso';
import Select from '../common/form/select';

import { setModoTela, initForm, salvar, excluir, excluirGeral, getListaResumido } from './laudoImportacaoActions';
import { getLista as getListaHospital } from '../hospital/hospitalActions';

class LaudoImportacao extends Component {

	state = {
		linhaSelecionada: null,
		competencia: `${new Date().getFullYear()}${String(new Date().getMonth() + 1).padStart(2, '0')}`
	}

	componentWillMount() {
        this.props.getListaResumido();
		this.props.getListaHospital();
    }

    render() {
		
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'importacao' ? (
						<LaudoImportacaoProcesso />
					) : null}
					{this.props.modoTela == 'listaImportada' ? (
						<Lista />
					) : null}
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		const lista = this.props.lista.filter(item => {
			console.log(this.state.competencia, ' == ', item.competencia);
			
			return this.state.competencia == item.competencia;
		});

		console.log(this.state.competencia);
		

		const listaHospital = this.state.competencia ? this.props.listaHospital.filter(hospital => !lista.filter(item => item.id_hospital == hospital.id).length) : [];

		const competencias = [];

		let data = new Date(2025, 0, 1); // Janeiro = 0
		const hoje = new Date();

		while (
			data.getFullYear() < hoje.getFullYear() ||
			(
				data.getFullYear() === hoje.getFullYear() &&
				data.getMonth() <= hoje.getMonth()
			)
		) {

			const mes = String(data.getMonth() + 1).padStart(2, '0');
			const ano = data.getFullYear();

			competencias.push({
				id: `${ano}${mes}`,
				valor: `${mes}/${ano}`
			});

			data.setMonth(data.getMonth() + 1);
		}

		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Select
							options={competencias}
							label='Competência' placeholder='Informe'
							cols='6 6 1 1'
							minWidth={200}
							value={this.state.competencia}
							onChange={value => {
								this.setState({
									competencia: value
								});
							}} />
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter width={100}>Competência</Th>
								<Th alignCenter width={400}>Hospital</Th>
								<Th alignCenter width={100}>Itens</Th>
								<Th alignCenter width={150}>Status</Th>
								<Th alignCenter width={100}></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => (
								<Tr>
									<Td alignCenter>{FormatUtils.formatarCompetenciaTela(item.competencia)}</Td>
									<Td alignCenter>{item.nome_hospital}</Td>
									<Td alignCenter>{item.itens || 0 }</Td>
									<Td alignCenter>
										<span
											style={{
												backgroundColor: '#d4edda',
												color: '#155724',
												padding: '4px 10px',
												borderRadius: 12,
												fontSize: 12,
												fontWeight: 'bold',
												display: 'inline-flex',
												alignItems: 'center',
												gap: 4,
												width: 120,
												textAlign: 'center',
												justifyContent: 'center'
											}} >
											Importado
										</span>
									</Td>
									<Td alignRight minWidth={10}>																			
										<ButtonTable
											type={'success'}
											icon={'fas fa-eye'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('listaImportada', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
											
										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												if (window.confirm('Deseja realmente excluir toda a importação?')) {
													this.props.excluirGeral({
														...item
													});
												}
											}} />
									</Td>
								</Tr>
							))}

							{listaHospital.map(item => (
								<Tr>
									<Td alignCenter>{FormatUtils.formatarCompetenciaTela(this.state.competencia)}</Td>
									<Td alignCenter>{item.valor}</Td>
									<Td alignCenter>{item.itens || 0 }</Td>
									<Td alignCenter>
										<span
											style={{
												backgroundColor: '#e0e0e0',
												color: '#666666',
												padding: '4px 10px',
												borderRadius: 12,
												fontSize: 12,
												fontWeight: 'bold',
												display: 'inline-flex',
												alignItems: 'center',
												gap: 4,
												width: 120,
												textAlign: 'center',
												justifyContent: 'center'
											}} >
											Não Importado
										</span>
									</Td>
									<Td alignRight minWidth={10}>																			
										<ButtonTable
											type={'success'}
											icon={'fas fa-file-upload'}
											visible={true}
											title='Importar'
											event={() => {
												this.props.setModoTela('importacao', {
													id_hospital: item.id,
													competencia: String(this.state.competencia)
												});
											}} />

										<ButtonTable
											type={'primary'}
											icon={'fas fa-pencil-alt'}
											visible={true}
											title='Adicionar Manual'
											event={() => {
												this.props.setModoTela('listaImportada', {
													id_hospital: item.id,
													nome_hospital: item.valor,
													competencia: String(this.state.competencia)
												});
												this.props.initForm({
													id_hospital: item.id,
													nome_hospital: item.valor,
													competencia: String(this.state.competencia)
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.laudoImportacao.modoTela,
	aguardando: state.laudoImportacao.aguardando,
	lista: state.laudoImportacao.lista,
	listaHospital: state.hospital.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, excluirGeral, getListaResumido,
	getListaHospital
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(LaudoImportacao);